<template>
  <header class="td" :class="{'fixed': fixed, 'header-transparent': isHome && !scrolled, 'scrolled': scrolled}">
    <button class="button visible-xs left" @click.stop="navShow = !navShow">
      <i class="ion-navicon-round"></i>
    </button>
    <div id="logo" class="hidden-xs">
      <router-link to="/">
        <img v-if="isHome && !scrolled" src="../../../static/images/logo/iPastBook-logo-white.svg" alt="logo" height="24"/>
        <img v-else src="../../../static/images/logo/iPastBook-logo-purple.svg" alt="logo" height="24"/>
        <img src="../../../static/images/logo/header-slogan.png" class="hidden-xs" alt="slogan" height="24"
             v-if="language.includes('zh') && !isHome"/>
      </router-link>
    </div>
    <div class="nav-list hidden-xs">
      <ul>
        <li>
          <router-link :to="{name: 'products', query: {type: 'diarybook'}}">{{$t('header.navProduct')}}</router-link>
        </li>
        <li>
          <router-link :to="{name: 'reviews'}">{{$t('header.navReviews')}}</router-link>
        </li>
        <template v-if="!user.uid">
          <li>
            <a href="/2.0/#home-faq">{{$t('header.navFAQ')}}</a>
          </li>
          <li>
            <a href="/2.0/products?type=diarybook#pricing">{{$t('header.navPricing')}}</a>
          </li>
        </template>
        <template v-else>
          <li>
            <router-link :to="{name: 'shelf'}">{{$t('header.navShelf')}}</router-link>
          </li>
          <li>
            <router-link :to="{name: 'order-list'}">{{$t('header.navOrder')}}</router-link>
          </li>
        </template>
      </ul>
    </div>
    <!--右边按钮-->
    <div class="user-profile text">
      <button v-if="user.uid && isShelf" class="btn gradient btn-sm btn-create-header" @click="$root.$emit('create-book')">
        <i class="fa fa-plus"></i>
        <span class="hidden-xs">{{$t('header.navStart')}}</span>
      </button>
      <router-link :to="{name: 'profile'}" v-if="user.uid" class="profile-link">
        <span class="header-avatar" :style="{backgroundImage: 'url(' + user.avatar + ')'}">
        </span>
      </router-link>
      <template v-if="!user.uid">
        <button class="btn gradient" @click="handleCreateBook">
          {{$t('header.navStart')}}
          <span class="btn-arrow"><i class="fa fa-arrow-right"></i></span>
        </button>
      </template>
    </div>
    <!--移动端顶部导航-->
    <transition name="transform">
      <nav-list v-if="navShow"></nav-list>
    </transition>
  </header>
</template>

<script>
import NavList from './NavList'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'i-header',
  props: {
    user: {
      type: Object,
      default: function () {
        return {}
      }
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  components: { NavList },
  data () {
    return {
      navShow: false,
      loginShow: false,
      scrolled: false
    }
  },
  computed: {
    ...mapGetters(['language']),
    isHome () {
      return this.$route && this.$route.name === 'home'
    },
    isProducts () {
      return this.$route && this.$route.name === 'products'
    },
    isShelf () {
      return this.$route && this.$route.name === 'shelf'
    }
  },
  created () {
  },
  mounted () {
    document.documentElement.addEventListener('click', this.handleClick, false)
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },
  beforeDestroy () {
    document.documentElement.removeEventListener('click', this.handleClick)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions([
      'setLoginShow'
    ]),
    handleClick () {
      this.navShow = false
    },
    handleScroll () {
      this.scrolled = window.scrollY > 50
    },
    handleCreateBook () {
      if (this.isHome || this.isProducts) {
        this.$root.$emit('show-social-modal')
      } else {
        this.setLoginShow(true)
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../styles/layout/Header.scss';
</style>
